import { TableBodyCell } from '../../../../../MyTickets.styled';
import { TicketTypeCellWrapper, Icon } from './TicketTypeCell.styled';
import { TicketTypeCellProps } from './TicketTypeCell.types';

import { ticketTypeLookUp } from 'src/components/Tickets/MyTickets.constants';

export const TicketTypeCell = ({ ticketTypeId }: TicketTypeCellProps) => {
  const IconComponent = ticketTypeId && ticketTypeLookUp[ticketTypeId]?.icon;

  return (
    <TableBodyCell>
      <TicketTypeCellWrapper>
        <Icon>{ticketTypeId && <IconComponent />}</Icon>
        <span>{ticketTypeLookUp[ticketTypeId].label}</span>
      </TicketTypeCellWrapper>
    </TableBodyCell>
  );
};
